import React, { useState } from "react";
import { toast } from "react-toastify";

const BookingComponent = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    destination: "",
    travelDate: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // 🔥 Transform FE form data → backend payload
    const payload = {
      name: formData.name,
      email: formData.email,
      destination: formData.destination,
      date: formData.travelDate,
      details: formData.message,
    };

    try {
      const res = await fetch("/api/contact/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        throw new Error("Submission failed");
      }

      toast.success("Thanks! We’ll be in touch shortly 🚀");

      setFormData({
        name: "",
        email: "",
        destination: "",
        travelDate: "",
        message: "",
      });
    } catch (err) {
      toast.error("Something went wrong. Please try again ❌");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="booking p-5">
          <div className="row g-5 align-items-center">

            <div className="col-md-6 text-white">
              <h1 className="text-white mb-4">Let's Get Started</h1>
              <p className="mb-4">
                Tell us about your ideal journey and we’ll take it from there.
              </p>
            </div>

            <div className="col-md-6">
              <form onSubmit={handleSubmit}>
                <div className="row g-3">

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control bg-white"
                        id="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="name">Your Name</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="email"
                        className="form-control bg-white"
                        id="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="email">Your Email</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="date"
                        className="form-control bg-white"
                        id="travelDate"
                        value={formData.travelDate}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="travelDate">Travel Start Date</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control bg-white"
                        id="destination"
                        value={formData.destination}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="destination">Destination</label>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="form-floating">
                      <textarea
                        className="form-control bg-white"
                        id="message"
                        value={formData.message}
                        onChange={handleChange}
                        style={{ height: 100 }}
                        required
                      />
                      <label htmlFor="message">Tell Us More..</label>
                    </div>
                  </div>

                  <div className="col-12">
                    <button
                      className="btn btn-primary w-100 py-3"
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? "Sending..." : "Contact Me"}
                    </button>
                  </div>

                </div>
              </form>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingComponent;
